import { useState, useEffect } from "react";
import {
  getDatabase,
  ref,
  query,
  orderByChild,
  equalTo,
  onValue,
} from "firebase/database";
import { useAuth } from "../contexts/AuthContext";

/**
 * Real-time count of listings with boatStatus === "Pending" (admin sidebar badge).
 */
export default function usePendingListingsCount() {
  const { userRole } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (userRole !== "Admin") {
      setCount(0);
      return undefined;
    }

    const db = getDatabase();
    const pendingQuery = query(
      ref(db, "listings"),
      orderByChild("boatStatus"),
      equalTo("Pending")
    );

    const unsubscribe = onValue(
      pendingQuery,
      (snapshot) => {
        setCount(snapshot.exists() ? snapshot.size : 0);
      },
      (error) => {
        console.error("Error listening to pending listings count:", error);
        setCount(0);
      }
    );

    return () => unsubscribe();
  }, [userRole]);

  return count;
}
